var map = {
	"./18.svg": 218,
	"./ShouldDelete.svg": 190,
	"./add_game.svg": 208,
	"./arrow-thin.svg": 104,
	"./arrowLeft.svg": 69,
	"./arrowRight.svg": 52,
	"./back.svg": 977,
	"./backspace.svg": 191,
	"./backward.svg": 978,
	"./betLogo.svg": 450,
	"./casinoRoulette.svg": 979,
	"./check.svg": 199,
	"./chevronDown.svg": 219,
	"./close-light.svg": 40,
	"./close.svg": 200,
	"./cross-eye.svg": 188,
	"./cross.svg": 39,
	"./delete.svg": 189,
	"./derbyLogo.svg": 451,
	"./edit.svg": 73,
	"./eye.svg": 187,
	"./filter.svg": 214,
	"./forward.svg": 134,
	"./four-dots.svg": 217,
	"./fullscreen-exit.svg": 207,
	"./fullscreen.svg": 206,
	"./ghost.svg": 124,
	"./heart.svg": 216,
	"./help.svg": 980,
	"./info-round.svg": 204,
	"./info.svg": 103,
	"./jackpot-mobile.svg": 220,
	"./lightning-icon.svg": 68,
	"./like.svg": 212,
	"./minimize.svg": 209,
	"./nemId.svg": 981,
	"./nemkonto.svg": 201,
	"./newsletter.svg": 982,
	"./nyheder.svg": 211,
	"./offers.svg": 983,
	"./puzzle.svg": 125,
	"./recommended.svg": 210,
	"./return.svg": 452,
	"./rodLogo.svg": 48,
	"./rodLogo_.svg": 984,
	"./rofus.svg": 49,
	"./search.svg": 102,
	"./sortArrows.svg": 215,
	"./star_wihout_bg.svg": 203,
	"./star_with_bg.svg": 202,
	"./succes.svg": 205,
	"./tableGames.svg": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 976;